<div *ngIf="to.label" class="label">{{ to.label }}</div>
<isp-chat
  [ngStyle]="{ fontSize: to.fontSize + 'px', fontFamily: to.fontFamily }"
  [messages]="to.messages"
></isp-chat>
